import { render, staticRenderFns } from "./PartnerModal.vue?vue&type=template&id=cc51a584&scoped=true&"
import script from "./PartnerModal.vue?vue&type=script&lang=ts&"
export * from "./PartnerModal.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerModal.vue?vue&type=style&index=0&id=cc51a584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc51a584",
  null
  
)

export default component.exports